import { copy } from './copy';
import { routes } from './routes';
import { theme } from './theme';

export const base = {
  copy,
  routes,
  theme,
};
